import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/new-studio/mobile/tool-redo.svg")